import { KeyboardAwareDrawer, KeyboardAwareDrawerContent } from "@components/KeyboardAwareDrawer";
import { Button } from "@shadcn/ui/button";
import { DrawerFooter, DrawerHeader, DrawerTitle } from "@shadcn/ui/drawer";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { TriangleAlert } from "lucide-react";
import { useState } from "react";
import z from "zod";
import { DoorClosingScreen } from "~/components/DoorClosingScreen";
import { useHelp } from "~/contexts/HelpContext";
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";

export const Route = createFileRoute("/$hubMetaName/pick-up/collect")({
	beforeLoad: () => {
		document.title = "bacehub | Startseite";
	},
	component: RouteComponent,
	validateSearch: zodValidator(
		z.object({
			unlockRequestId: z.string(),
			finishPath: z.string().optional(),
			problemPath: z.string().optional(),
		})
	),
});

export default function RouteComponent() {
	const navigate = useNavigate();
	const { unlockRequestId, finishPath, problemPath } = Route.useSearch();
	const { openIntercom } = useHelp();
	const i18n = useI18nContext().LL["new-ui"];
	const [problemDrawerOpen, setProblemDrawerOpen] = useState(false);

	const handleProblemClick = () => {
		if (problemPath) {
			setProblemDrawerOpen(true);
			return;
		}

		openIntercom();
	};

	return (
		<>
			<DoorClosingScreen
				unlockRequestId={unlockRequestId}
				footer={
					<Button variant="ghost" size="lg" className="w-full" onClick={handleProblemClick}>
						<TriangleAlert />
						<T>{i18n.I_HAVE_PROBLEM()}</T>
					</Button>
				}
				onExit={() => navigate({ to: "/" })}
				onClosed={() => {
					if (finishPath) navigate({ to: finishPath });
					else navigate({ from: Route.fullPath, to: "/$hubMetaName/pick-up/finish" });
				}}
			/>
			<KeyboardAwareDrawer open={problemDrawerOpen} onOpenChange={setProblemDrawerOpen}>
				<KeyboardAwareDrawerContent>
					<DrawerHeader className="text-left">
						<DrawerTitle>
							<T>{i18n.I_HAVE_PROBLEM()}</T>
						</DrawerTitle>
					</DrawerHeader>
					<DrawerFooter>
						<Button
							size="lg"
							onClick={() => {
								setProblemDrawerOpen(false);
								if (!problemPath) {
									return;
								}
								navigate({ to: problemPath });
							}}
						>
							<T>{i18n.OPEN_DOOR()}</T>
						</Button>
						<Button
							variant="outline"
							size="lg"
							onClick={() => {
								setProblemDrawerOpen(false);
								openIntercom();
							}}
						>
							<T>{i18n.LIVE_CHAT()}</T>
						</Button>
					</DrawerFooter>
				</KeyboardAwareDrawerContent>
			</KeyboardAwareDrawer>
		</>
	);
}
